import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = loc.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }

    api.post("/auth/session", { session_id: match[1] })
      .then(async () => {
        window.history.replaceState({}, "", "/account");
        await refresh();
        nav("/account", { replace: true });
      })
      .catch(() => nav("/login"));
  }, [loc, nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fcfbf8]">
      <div className="text-center">
        <div className="font-serif text-2xl text-[#7a1e2b]">Signing you in…</div>
        <div className="font-italic-serif text-[#7c7273] mt-2">Grace in every drape.</div>
      </div>
    </div>
  );
}
